"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;
var _react = _interopRequireDefault(require("react"));
var _yup = require("@hookform/resolvers/yup");
var _reactHookForm = require("react-hook-form");
var yup = _interopRequireWildcard(require("yup"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _validations = require("../../../../../validations");
var _ui = require("../../../../ui");
var _fields = require("../../../../fields");
var _SendEmailConfirm = require("../SendEmailConfirm");
var _SaveChangesButton = require("../SaveChangesButton");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var schema = yup.object().shape({
  email: (0, _validations.emailValidation)().required()
}).required();
var Component = function Component(_ref) {
  var onSubmit = _ref.onSubmit,
    updateEmailDisabled = _ref.updateEmailDisabled,
    submitLoading = _ref.submitLoading,
    email = _ref.email,
    showConfirmButton = _ref.showConfirmButton;
  var _useTranslation = (0, _reactI18next.useTranslation)(['libSettings', 'libCommon']),
    t = _useTranslation.t;
  var _useForm = (0, _reactHookForm.useForm)({
      resolver: (0, _yup.yupResolver)(schema),
      defaultValues: {
        email: email
      }
    }),
    handleSubmit = _useForm.handleSubmit,
    control = _useForm.control;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true
  }, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/_react.default.createElement(_ui.Label, {
    htmlFor: "email"
  }, t('libCommon:email')), showConfirmButton && /*#__PURE__*/_react.default.createElement(_SendEmailConfirm.SendEmailConfirm, null)), /*#__PURE__*/_react.default.createElement(_fields.InputField, {
    control: control,
    inputProps: {
      name: 'email',
      disabled: updateEmailDisabled,
      placeholder: t('libCommon:email')
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.Row, null, /*#__PURE__*/_react.default.createElement(_ui.Col, {
    md: 12,
    lg: 6
  }, /*#__PURE__*/_react.default.createElement(_SaveChangesButton.SaveChangesButton, {
    disabled: updateEmailDisabled,
    loading: submitLoading,
    wide: true
  }))));
};
exports.Component = Component;